import { defineMessages } from 'react-intl';

export const freightBrowserContainerMessages = defineMessages({
  noProviderConnected: {
    id: 'U/KQsj',
    description:
      'Error shown when no freight provider is connected and the user tries to browse rates. {link} wraps "Settings" as a link to the carrier settings page.',
    defaultMessage: 'No freight provider connected. Please connect a provider in <link>Settings</link>.',
  },
  noShipFromSelected: {
    id: 'g4K8kP',
    description: 'Error shown when no ship from warehouse is selected',
    defaultMessage: 'No Ship From Warehouse has been selected.',
  },
  failedToRetrieveQuotes: {
    id: '9ElxZE',
    description: 'Error shown when the freight quote request returns no usable quotes',
    defaultMessage: 'Failed to retrieve quotes.',
  },
  rateFetchError: {
    id: 'prvC/m',
    description: 'Generic error shown when an unexpected error occurs while fetching freight rates',
    defaultMessage: 'An error occurred while fetching rates.',
  },
  quoteTimedOut: {
    id: 'v2GfPN',
    description: 'Error shown when freight quote request times out waiting for Pusher response',
    defaultMessage: 'Quote request timed out. Please try again.',
  },
  saveQuoteFailed: {
    id: 'uJ/nCL',
    description: 'Fallback error shown in a notification when saving a freight quote fails without a server message',
    defaultMessage: 'Failed to save quote.',
  },
  saveQuoteSuccess: {
    id: 'NB7+v2',
    description: 'Content of the notification shown when a freight quote is saved successfully',
    defaultMessage: 'Saved quote.',
  },
});
